import { WebPlugin } from '@capacitor/core';

import type { TestFlightDetectPlugin } from './definitions';

export class TestFlightDetectWeb
  extends WebPlugin
  implements TestFlightDetectPlugin
{
  async checkTF(): Promise<{ "isFromTestFlight": boolean, "isInSimulator": boolean, "isFromAppStore": boolean }> {
    throw this.unimplemented('Not implemented on web.');
  }
}
